import { GlassSurface } from "@akili/auth-kit";
import { cn } from "@/lib/utils";

export interface V2Tile {
  /** Stable React key; defaults to the label. */
  key?: string;
  value: string;
  label: string;
}

export interface V2TilesProps {
  tiles: readonly V2Tile[];
  /**
   * `glass` — frosted tiles on the stage (the proof pane's numbers).
   * `card` — solid tiles inside a glass card (welcome, success, checkout).
   */
  surface?: "glass" | "card";
  className?: string;
  testId?: string;
}

/** A row of value + label tiles. Three columns; one per tile when there are fewer. */
export function V2Tiles({ tiles, surface = "card", className, testId = "v2-tiles" }: V2TilesProps) {
  if (tiles.length === 0) return null;
  const cols = tiles.length >= 3 ? "grid-cols-3" : tiles.length === 2 ? "grid-cols-2" : "grid-cols-1";
  return (
    <div className={cn(className, "grid", cols, "gap-2.5")} data-testid={testId}>
      {tiles.map((tile) =>
        surface === "glass" ? (
          <GlassSurface key={tile.key ?? tile.label} radius="control" className="px-3 py-3">
            <b className="font-auth-sans block text-[22px] font-semibold tracking-[-0.02em]">{tile.value}</b>
            <span className="text-auth-mute text-xs">{tile.label}</span>
          </GlassSurface>
        ) : (
          <div
            key={tile.key ?? tile.label}
            className="border-auth-line bg-auth-field rounded-auth-control dark:border-auth-glass-line-inverted border px-3.5 py-3 text-left dark:bg-white/5"
          >
            <b className="font-auth-sans text-auth-text dark:text-auth-on-ink block text-[20px] font-semibold tracking-[-0.02em]">
              {tile.value}
            </b>
            <span className="text-auth-mute dark:text-auth-on-ink-mute text-xs">{tile.label}</span>
          </div>
        ),
      )}
    </div>
  );
}
